import React, { Fragment } from "react";
import { useParams } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";



import PackageHero from "../components/PackageDetail/PackageHero";
import PackageOverview from "../components/PackageDetail/PackageOverview";
import ComplimentaryServices from "../components/PackageDetail/ComplimentaryServices";
import packages from "../data/OurPackagesSection/packagesSection.json";
import InclusionsSection from "../components/PackageDetail/InclusionsSection";
import RelatedServices from "../components/PackageDetail/RelatedServices";


const OurPackageDetailsPage = () => {
  const { slug } = useParams();

  // find selected package by slug
  const packageData = packages.find(
    (item) => item.slug === slug
  );

  // safety check
  if (!packageData) {
    return null;
  }

  return (
    <Fragment>
      <Header />

 
      <PackageHero
        title={packageData.title}
        detailImage={packageData.detailImage}
      />


      <PackageOverview
        title={packageData.title}
        overview={packageData.overview}
        gallery={packageData.gallery}
      />
      
<ComplimentaryServices
  services={packageData.complimentary}
  />
<InclusionsSection rooms={packages} />

<RelatedServices
  services={packages.filter(
    (item) => item.slug !== packageData.slug
  ).slice(0, 3)}
/>


      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default OurPackageDetailsPage;
